// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__yzXe3","card__lottie":"styles_card__lottie__iB68x","skeleton-animation":"styles_skeleton-animation__SNg9j"};